import { downloadFromBlobUrl } from "../../../../../common/utils/download_utils";
import { IDownloadColetaPrecoArquivoUseCase } from "../../../presentation/useCases/read/download_coleta_preco_arquivo_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DownloadColetaPrecoArquivoUseCase
 */

export class DownloadColetaPrecoArquivoUseCase implements IDownloadColetaPrecoArquivoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async downloadColetaPrecoArquivo(
    idColetaPreco: number,
    nroArquivo: number,
    nomeArquivo: string,
  ): Promise<void> {
    const result = await this.repository.downloadColetaPrecoArquivo(idColetaPreco, nroArquivo);
    await downloadFromBlobUrl(result, nomeArquivo);
  }
}
